import { useState, useCallback } from "react";
import { useDispatch } from 'react-redux';
import { openModal, closeModal } from 'store/slice/SliceModal';

export function useModal() {
    const [isOpenModal, setIsOpenModal] = useState(false);

    const openModal = useCallback(() => setIsOpenModal(true), []);
    const closeModal = useCallback(() => setIsOpenModal(false), []);

    return { isOpenModal, openModal, closeModal };
}

export function useReduxModal() {
    const dispatch = useDispatch();

    const showModal = useCallback((modalConfig) => {
        dispatch(openModal({
            modalType: 'basic',
            modalProps: {
                title: modalConfig.title,
                message: modalConfig.message || modalConfig.description,
                severity: modalConfig.severity || 'info'
            }
        }));
    }, [dispatch]);

    const hideModal = useCallback(() => {
        dispatch(closeModal());
    }, [dispatch]);

    const showProgressModal = useCallback(() => {
        dispatch(openModal({ 
            modalType: 'progress',
            modalProps: {
                title: '처리중',
                message: '잠시만 기다려주세요...',
                severity: 'info'
            }
        }));
    }, [dispatch]);

    return { showModal, hideModal, showProgressModal };
}
